import { lazy, Suspense } from 'react'
import { type LocationDetail } from '@/api/accommodation/types'
import { Typography } from '@/components/ui/typography'
import LocationCard from './LocationCard'

const Map = lazy(() => import('./Map'))

interface DetailLocationSectionProps {
  location: LocationDetail
}

export function DetailLocationSection({ location }: DetailLocationSectionProps) {
  return (
    <div id="map" className="scroll-mt-38 space-y-4 lg:scroll-mt-16">
      <Typography variant="h2">Kde se ubytování nachází</Typography>

      <LocationCard location={location} />
      <div>
        <Suspense fallback={<div className="aspect-5/3 w-full animate-pulse rounded-2xl bg-slate-100" />}>
          <Map location={location.address} />
        </Suspense>
      </div>
    </div>
  )
}
